export default [
    {
        "fa": "fas fa-user-graduate",
        "value": "National Intern Day 2026",
        "linkTo": "https://www.radnet.com/national-intern-day?fbclid=IwdGRleATYVENwZG9mAWZkaWQWULjDLGRvCa0eKgc98VZYqdRa0kbxXGV4dG4DYWVtAjExAHNydGMGYXBwX2lkCjY2Mjg1NjgzNzkAAR6pWLe4qQJ-lOW3ypTtehfLvOxCN1O4xEKRO-e0ujdgSfPoETmVchSzN2LWuw_aem_VWS69tMuDXSYQjYiTXD-0A"
    },
    {
        "fa": "fas fa-ribbon",
        "value": "National Cancer Survivor Month",
        "linkTo": "https://www.radnet.com/national-cancer-survivors-month"
    },
    {
        "fa": "fas fa-chart-line",
        "value": "RadNet Investor Day 2025",
        "linkTo": "https://www.radnet.com/investor-day?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=investor_day"
    },
    {
        "fa": "fab fa-facebook",
        "value": "Facebook",
        "linkTo": "https://www.facebook.com/RadNetInc/"
    },
    {
        "fa": "fa-brands fa-x-twitter",
        "value": "Twitter",
        "linkTo": "https://twitter.com/RadNet_Inc"
    },
    {
        "fa": "fab fa-linkedin",
        "value": "Linkedin",
        "linkTo": "https://www.linkedin.com/company/14101/admin/"
    },
    {
        "fa": "fas fa-microphone",
        "value": "Dr. Howard Berger iHeartRadio Interview",
        "linkTo": "https://kfiam640.iheart.com/featured/ceos-you-should-know-la/content/2025-08-ceos-you-should-know-howard-berger-ceo-founder-of-radnet/"
    }
]